import appLocaleData from 'react-intl/locale-data/zh'
import zhhantMessages from './zh-Hant.messages.json'

export default {
  messages: {
    ...zhhantMessages,
  },
  locale: 'zh-Hant-TW',
  data: appLocaleData,
}



// WEBPACK FOOTER //
// ./src/locales/zh-Hant.js